module.exports = __webpack_public_path__ + "static/Bio-pic-de18b9da87f50ca247bdb4ddbbc84e7f.svg";